import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import DetailedStatistics from '../../components/Stats/DetailedStatistics';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const StoryStatisticsPage = () => {
  const page = `${Page.stories}`;
  const fetch = useFetch();
  const [story, setStory] = useState();
  const [error, setError] = useState();
  const { accountId, domainId, id } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/stories/${id}`)
      .then(({ story }) => setStory(story))
      .catch(setError);
  }, [accountId, domainId, id, fetch]);

  return (
    <>
      <Metadata title={`${page} | ${story?.name || 'Unnamed story'}`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/stories`}>Stories</Anchor>
        <Text>{story?.name || 'Unnamed story'}</Text>
      </Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <DetailedStatistics name={story?.name} scope="stories" id={id} />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default StoryStatisticsPage;
